<ion-app>
    <ion-split-pane when="lg" contentId="main-content">
        @if (isAuthenticated()) {
        <ion-menu menuId="app-menu" contentId="main-content" type="overlay" class="app-side-menu">
            <ion-header>
                <ion-toolbar color="primary">
                    <ion-title>
                        <img src="assets/icon/digimep-logo-light.svg" alt="DigiMEP" />
                    </ion-title>
                </ion-toolbar>
            </ion-header>

            <ion-content>
                <ion-list lines="full">
                    @for (item of menuItems(); track item.id) {
                    <ion-menu-toggle menu="app-menu" autoHide="false">
                        <ion-item button detail="false" lines="full" class="app-side-menu__item" [routerLink]="item.route" routerLinkActive="app-side-menu__item--active">
                            <ion-icon slot="start" class="app-side-menu__lead-icon" [name]="item.icon" aria-hidden="true"></ion-icon>
                            <ion-label>{{ item.label }}</ion-label>
                            <ion-icon slot="end" class="app-side-menu__trail-icon" name="chevron-forward-outline" aria-hidden="true"></ion-icon>
                        </ion-item>
                    </ion-menu-toggle>
                    }
                </ion-list>
            </ion-content>

            <ion-footer>
                <ion-item lines="none" class="ion-text-center">
                    <ion-label class="app-side-menu__version">Version {{ appVersion() }}</ion-label>
                </ion-item>
            </ion-footer>
        </ion-menu>
        }

        <ion-router-outlet [animated]="false" id="main-content"></ion-router-outlet>
    </ion-split-pane>
</ion-app>